import { IonLoading } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { Redirect, useParams } from 'react-router';
import { resourceHelper } from '../../helpers';
import {
  conversationResource,
  customerResource,
  expertResource,
} from '../../resource';

export const ConversationRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [redirectPath, setRedirectPath] = useState<string | null>(null);
  const [redirectState, setRedirectState] = useState<object | null>(null);

  useEffect(() => {
    conversationResource
      .find(`/conversations/${id}`)
      .then(response => {
        if (!response) {
          setRedirectPath('/expert/dashboard');
          return;
        }

        const idCustomer = resourceHelper.getIdFromIri(
          response.customer['@id'],
          customerResource,
        );
        const idExpert = resourceHelper.getIdFromIri(
          response.expert['@id'],
          expertResource,
        );

        setRedirectState({
          idConversation: response['@id'],
          readOnly: response.status === 'finished',
        });
        setRedirectPath(`/expert/conversation/${idExpert}/${idCustomer}`);
      })
      .catch(() => {
        setRedirectPath('/expert/dashboard');
      });
  }, [id]);

  if (redirectPath) {
    return <Redirect to={{ pathname: redirectPath, state: redirectState }} />;
  }

  return <IonLoading isOpen={true} message="Loading..." />;
};
